import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: 'auth', loadChildren: () => import('./authorization/authorization.module').then(m => m.AuthorizationModule) },
    { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
    // { path: '', redirectTo: 'auth/signin', pathMatch: 'full'},
    { path: '', redirectTo: 'pages/dashboard', pathMatch: 'full'},
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
